const Loader = () => {
  return (
    <div className="pageloader is-bottom-to-top is-active">
      <span className="title is-size-1 mt0">Loading...</span>
    </div>
  );
};

export default Loader;
